export const isNotSupportedMedia = (mimeType, supportedMediaTypePrefix) =>
  mimeType && supportedMediaTypePrefix && mimeType.indexOf(`${supportedMediaTypePrefix}/`) === -1;

export const isValidFileSize = file => {
  const fiveMbLimit = 5 * 1024 * 1024;
  return file.size < fiveMbLimit;
};

const readFile = (id, file, onAttachmentAdded) => {
  const reader = new FileReader();
  reader.onloadend = () => {
    onAttachmentAdded({ name: id, file, imagePreviewUrl: reader.result });
  };
  reader.readAsDataURL(file);
  return;
};

export const loadFile = (id, file, onAttachmentAdded) => {
  const hh = require("heic2any");
  return new Promise((resolve, reject) => {
    if (file.name.indexOf("heic") > -1) {
      hh({ blob: file, toType: "image/jpeg", quality: 0.7 })
        .then(resp => readFile(id, resp, onAttachmentAdded))
        .then(() => resolve())
        .catch(reject);
    } else {
      try {
        readFile(id, file, onAttachmentAdded);
        resolve();
      } catch (error) {
        reject(error);
      }
    }
  });
};
